import env from 'configuration'

// Deliberately uses raw fetch instead of utils/api's axios wrapper — this
// needs to work even if something in the axios/app setup itself is what's
// broken, and it must never throw (a reporter that crashes while reporting
// a crash is worse than no reporter).
export function reportClientError(error, extra) {
  try {
    const body = JSON.stringify({
      message: error?.message || String(error),
      stack: error?.stack,
      url: window.location.href,
      userAgent: navigator.userAgent,
      extra,
    })
    fetch(`${env.API_URL}/v1/client-error`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => {})
  } catch (e) {
    // swallow — reporting must never itself throw
  }
}
